import * as React from "react"

const SvgSwatchBook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m3.975 19.8-.85-.35a1.76 1.76 0 0 1-1.037-1.125 2.1 2.1 0 0 1 .087-1.575l1.8-3.9zm4 2.2q-.824 0-1.412-.587A1.93 1.93 0 0 1 5.975 20v-6l2.65 7.35q.075.176.15.337.075.163.2.313zm5.15-.1q-.8.3-1.55-.075c-.75-.375-.85-.642-1.05-1.175l-4.45-12.2a1.96 1.96 0 0 1 .05-1.562 1.9 1.9 0 0 1 1.15-1.038l7.55-2.75q.8-.3 1.55.075c.75.375.85.642 1.05 1.175l4.45 12.2q.3.8-.05 1.563a1.9 1.9 0 0 1-1.15 1.037zM10.975 10q.424 0 .713-.287A.97.97 0 0 0 11.975 9a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712q0 .424.288.713a.97.97 0 0 0 .712.287m1.45 10 7.55-2.75L15.525 5l-7.55 2.75z" />
  </svg>
)
export default SvgSwatchBook
